var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddicon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_675",
    "data-name": "Group 675",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 57,
    viewBox: "0 0 40 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_88_-_Outline",
    "data-name": "Union 88 - Outline",
    d: "M21232.156,6462.3a2.029,2.029,0,0,1-2.031-2.031v-6.086h-6.094a2.031,2.031,0,1,1,0-4.062h6.094v-6.092a2.031,2.031,0,0,1,4.063,0v6.092h6.09a2.031,2.031,0,1,1,0,4.063h-6.09v6.086A2.032,2.032,0,0,1,21232.156,6462.3Z",
    transform: "translate(-21212.008 -6423.763)",
    fill: "#00246a"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_311",
    "data-name": "Rectangle 311",
    width: 40,
    height: 57,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddicon2);
export default __webpack_public_path__ + "static/media/Addicon (2).18364f62e7701049ca5bebb6f0c5ce68.svg";
export { ForwardRef as ReactComponent };